import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import DefaultErrorComponent from '../DefaultErrorComponent';
import { DefaultLoadingComponent } from '../DefaultLoadingComponent';
const ManageViewsPageAsync = Loadable({
  loader: () => import( /* webpackChunkName: "manage-queues-page" */'./ManageQueuesPage').then(mod => mod.default),
  LoadingComponent: DefaultLoadingComponent,
  ErrorComponent: DefaultErrorComponent
});
export default ManageViewsPageAsync;